import { Icon, IconsEnum } from '../../Icons';
import { AnchorLink, AnchorLinkType } from '../../anchorLink';
import styles from './PokerButtonGame.module.scss';
export type PokerButtonGameProps = {
  label?: string;
  link?: AnchorLinkType;
  iconName: IconsEnum;
  isLogin?: boolean;
  children: React.ReactNode;
  handleOnClick?: Function;
};

export const PokerButtonGame = ({ link, iconName, handleOnClick, children }: PokerButtonGameProps) => {
  return link ? (
    <AnchorLink href={link.href} className={styles.pokerLink}>
      <div className={styles.wrapper}>
        <div className={styles.iconContainer}>
          <Icon iconId={iconName} color="var(--color-accent)" className={styles.icon} />
        </div>
        {children}
      </div>
    </AnchorLink>
  ) : (
    <button
      onClick={() => {
        handleOnClick && handleOnClick();
      }}
      className={styles.pokerButton}
    >
      <div className={styles.wrapper}>
        <div className={styles.iconContainer}>
          <Icon iconId={iconName} color="var(--color-accent)" className={styles.icon} />
        </div>
        {children}
      </div>
    </button>
  );
};
